import type { PreviousReloadFormResponse, ReloadFormRequest } from 'apiConnector/secondary-market/cp-order/model';
import type { Custodian } from 'models/custodian';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type { TradeWay } from 'state/secondaryMarket/secondaryMarket.model';
import type { WorkspaceType } from 'state/workspaces/model';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';
import type { HttpErrorKind } from 'utils/errors/errors';

export type SecondaryMarketCpOrderProductActions =
  | SecondaryMarketCpOrderInitFormFetchRequested
  | SecondaryMarketCpOrderReloadFormFetchRequested
  | SecondaryMarketCpOrderInitFormFetched
  | SecondaryMarketCpOrderReloadFormFetched
  | SecondaryMarketCpOrderInitFormFetchedFailed
  | SecondaryMarketCpOrderReloadFormFetchedFailed;

// ////////////////////////////////////
export function secondaryMarketCpOrderInitFormFetchRequested(
  tabId: string,
  bcsProductKey: BcsProductKey,
  tradeWay?: TradeWay,
  client?: ISalesCounterpart,
  custodian?: Custodian,
) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_INIT_FORM_FETCH_REQUESTED' as const,
    tabId,
    workspace: 'secondaryMarketQuotes' as WorkspaceType,
    bcsProductKey,
    tradeWay,
    client,
    custodian,
  };
}

export type SecondaryMarketCpOrderInitFormFetchRequested = ReturnType<
  typeof secondaryMarketCpOrderInitFormFetchRequested
>;

// ////////////////////////////////////

export function secondaryMarketCpOrderInitFormFetched(tabId: string, response: PreviousReloadFormResponse) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_INIT_FORM_FETCHED' as const,
    tabId,
    workspace: 'secondaryMarketQuotes' as WorkspaceType,
    response,
  };
}

export type SecondaryMarketCpOrderInitFormFetched = ReturnType<typeof secondaryMarketCpOrderInitFormFetched>;

// ////////////////////////////////////

export function secondaryMarketCpOrderInitFormFetchedFailed(
  tabId: string,
  message?: string,
  errorKind?: HttpErrorKind,
) {
  return {
    type: 'SECONDARY_MARKET_CP_ORDER_INIT_FORM_FETCH_FAILED' as const,
    workspace: 'secondaryMarketQuotes' as WorkspaceType,
    tabId,
    message,
    errorKind,
  };
}

export type SecondaryMarketCpOrderInitFormFetchedFailed = ReturnType<
  typeof secondaryMarketCpOrderInitFormFetchedFailed
>;

// ////////////////////////////////////

export function secondaryMarketCpOrderReloadFormFetchRequested(
  tabId: string,
  workspace: WorkspaceType,
  request: ReloadFormRequest,
) {
  return { type: 'SECONDARY_MARKET_CP_ORDER_RELOAD_FORM_FETCH_REQUESTED' as const, tabId, workspace, request };
}

export type SecondaryMarketCpOrderReloadFormFetchRequested = ReturnType<
  typeof secondaryMarketCpOrderReloadFormFetchRequested
>;

// ////////////////////////////////////

export function secondaryMarketCpOrderReloadFormFetched(
  tabId: string,
  workspace: WorkspaceType,
  response: PreviousReloadFormResponse,
) {
  return { type: 'SECONDARY_MARKET_CP_ORDER_RELOAD_FORM_FETCHED' as const, tabId, workspace, response };
}

export type SecondaryMarketCpOrderReloadFormFetched = ReturnType<typeof secondaryMarketCpOrderReloadFormFetched>;

// ////////////////////////////////////

export function secondaryMarketCpOrderReloadFormFetchedFailed(
  tabId: string,
  workspace: WorkspaceType,
  message?: string,
  errorKind?: HttpErrorKind,
) {
  return { type: 'SECONDARY_MARKET_CP_ORDER_RELOAD_FORM_FETCH_FAILED' as const, tabId, workspace, message, errorKind };
}

export type SecondaryMarketCpOrderReloadFormFetchedFailed = ReturnType<
  typeof secondaryMarketCpOrderReloadFormFetchedFailed
>;
